import React from 'react';
import cx from 'classnames';
import styles from './index.module.scss.js';

const Switch = ({
  className,
  style,
  size = "large",
  theme = "grey-2",
  flow = "default",
  isFullWidth = false,
  ariaLabel,
  isChecked,
  onCheck,
  label,
  ...props
}) => {
  const toggle = () => onCheck?.(!isChecked);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      ...props,
      className: cx(
        styles.box,
        className,
        {
          [styles[flow]]: flow,
          [styles.full]: isFullWidth,
          [styles[theme]]: !!theme,
          [styles.active]: isChecked,
          [styles[size]]: !!size
        },
        "switch-box"
      ),
      style
    },
    /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: styles.button,
        onClick: toggle,
        "aria-label": ariaLabel || (typeof label === "string" ? label : ""),
        role: "checkbox",
        "aria-checked": isChecked
      },
      /* @__PURE__ */ React.createElement(
        "svg",
        {
          className: styles.svg,
          width: "32",
          height: "16",
          viewBox: "0 0 32 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          "aria-hidden": true
        },
        /* @__PURE__ */ React.createElement(
          "rect",
          {
            y: "0.41449",
            width: "31.93",
            height: "15.4145",
            rx: "7.70724",
            className: styles.bg
          }
        ),
        /* @__PURE__ */ React.createElement(
          "rect",
          {
            x: "2.20166",
            y: "2.61682",
            width: "11.0103",
            height: "11.0103",
            rx: "5.50517",
            className: styles.circle
          }
        )
      )
    ),
    label && /* @__PURE__ */ React.createElement("p", { className: styles.label, onClick: toggle }, label)
  );
};
Switch.displayName = "Form.Switch";

export { Switch };
//# sourceMappingURL=index.js.map
